<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :isRequiredFarms="true"
              :isRequiredLots="false"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              classFarms="col-lg-6"
              classLots="col-lg-6"
            >
              <template slot="prev">
                <div class="col-12 col-sm-12 col-md-6 col-lg-4 pt-3">
                  <label for="">{{ $t('common_words.activities') }}: </label>
                  <br />
                  <el-select
                    @change="
                      selectAllFromSelect('dataFilter.activities', activities)
                    "
                    clearable
                    collapse-tags
                    style="width: 100%"
                    multiple
                    filterable
                    class="select-primary custom-width-select shadow-sm"
                    v-model="dataFilter.activities"
                    :placeholder="`${$t('common_words.select2')}...`"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="(item, index) in activities"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-4 pt-3">
                  <label for="">{{ $t('labor.workers') }}: </label>
                  <br />
                  <el-select
                    @change="selectAllFromSelect('dataFilter.workers', workers)"
                    clearable
                    collapse-tags
                    style="width: 100%"
                    multiple
                    filterable
                    class="select-primary custom-width-select shadow-sm"
                    v-model="dataFilter.workers"
                    :placeholder="`${$t('common_words.select2')}...`"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="(item, index) in workers"
                      :key="index"
                      :label="`${item.name}`"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-4 pt-3">
                  <label for="">{{ $t('labor.hour_type') }}: </label>
                  <br />
                  <el-select
                    @change="
                      selectAllFromSelect('dataFilter.timeTypes', timeTypes)
                    "
                    clearable
                    collapse-tags
                    style="width: 100%"
                    multiple
                    filterable
                    class="select-primary custom-width-select shadow-sm"
                    v-model="dataFilter.timeTypes"
                    :placeholder="`${$t('common_words.select2')}...`"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="(item, index) in timeTypes"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <card v-if="tableData.length > 0">
        <br />
        <div v-if="isIndex()">
          <card-header
            :propPagination="pagination"
            @searchedQuery="searchedQuery"
            class="mr-3 mt-1"
          ></card-header>
          <master-table
            :cellStyle="handlecellstyle"
            :infoTable="queriedData"
            :columns="tableColumns"
            :showColumnStatus="false"
          >
          </master-table>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" :propPagination="pagination" />
        <div class="mt-3">
          <div class="align-exportable">
            <div class="px-3" v-if="isPDF()">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="exportToPDF"
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
            <div class="px-3" v-if="isExcel()">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportXLS()"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
            <div class="px-3">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                style="
                  background-color: #0079c1 !important;
                  border-color: #0079c1 !important;
                "
                @click="exportToXlsx()"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_sap') }}
              </button>
            </div>
          </div>
        </div>
        <br />
      </card>
      <div v-if="details" class="col-12 text-center">
        <em
          class="nc-icon nc-stre-up"
          style="font-size: 25px; cursor: pointer"
          @click="handleViewDetails"
          v-tooltip.top-center="$t('common_words.hide_detail')"
        ></em>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Pagination as LPagination } from 'src/components/index';
import configTable from './activities-sheet-table';
import Filter from 'src/components/Filter/Filters.vue';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import MixinCalculateExtraHourWeek from './mixin-calculate-extra-hours-week';
import MixinExport from './mixin-export';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [Filter.name]: Filter,
    LPagination,
  },
  computed: {
    ...configTable().Search,
    getDataToExport() {
      const response = { ...this.dataFilter };
      delete response.route;

      return response;
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },
  data() {
    return {
      activeName: 'filter',
      activities: [],
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      dataFilter: {
        datef: moment().format('YYYY-MM-DD'),
        datei: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        labors: [],
        farm: [],
        lot: [],
        timeTypes: [],
        activities: [],
        workers: [],
      },
      details: false,
      detailsForm: {},
      fuseSearchDetails: null,
      model: null,
      pagination: {},
      tableColumns: [],
      valueCollapse: null,
      reportType: 0,
      timeTypes: [],
      workers: [],
      extraHoursByWeek: null,
    };
  },
  mixins: [
    mixinMasters,
    MixinMenu,
    MixinPermissions,
    MixinCalculateExtraHourWeek,
    MixinExport,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    searchedQueryDetails(searchedValue) {
      this.searchQueryDetails = searchedValue;
    },

    getExtraWeekHours(row) {
      return this.extraHoursByWeek
        .filter((item) => item.week_save === row.week_save)
        .reduce((acc, item) => acc.concat(item.workers), [])
        .filter((item) => item.worker_id === row.worker_id)
        .reduce((acc, item) => acc + item.total_extra_day_hours, 0);
    },

    getExtraWeekHourExceedByWorker(row) {
      const match = this.extraHoursByWeek
        .filter((item) => item.week_save === row.week_save)
        .reduce((acc, item) => acc.concat(item.workers), [])
        .find((item) => item.worker_id === row.worker_id);

      return match ? match.is_extra_week_hour_exceed : null;
    },

    handlecellstyle({ row }) {
      const isExtraWeekHouExceed = this.getExtraWeekHourExceedByWorker(row);

      if (
        !row.subtotal ||
        row.is_daily_hour_exceeds == true ||
        (row.extra_day_hours && Number(row.extra_day_hours) > 4) ||
        isExtraWeekHouExceed == true
      ) {
        return 'background-color: #fde6e4;';
      } else return '';
    },

    handleViewDetails() {
      this.details = !this.details;
      this.tableData.forEach((element) => {
        element.show = true;
      });
    },

    handleFilter(data) {
      this.dataFilter = { ...this.dataFilter, ...data };
      this.details = false;
      this.getDataSamples();
    },

    getDataSamples() {
      this.showHideLoading(true);
      let data = this.dataFilter;
      data.route = 'works/activitysheets';
      Axios.postMasters(data)
        .then((response) => {
          if (response.data.data.labor_data.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.tableData = response.data.data.labor_data;
            this.fuseSearch = new Fuse(this.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumns.map((prop) => {
                return prop.prop;
              }),
            });
            this.pagination.perPage = 5;
            this.pagination.currentPage = 1;
            this.searchQuery = '';
            this.extraHoursByWeek = response.data.data.extra_hours_by_week;
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
      this.pagination.perPage = 5;
      this.pagination.currentPage = 1;
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },
  },
  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading();

      Axios.getMasters('works/workers/indexField').then((response_workers) => {
        this.workers = this.concatAll(response_workers.data.data);
      });

      Axios.getMasters('works/activities/field').then((response_activities) => {
        this.activities = this.concatAll(response_activities.data.data);
      });

      Axios.getMasters('works/timetypes/field').then((response_time_types) => {
        this.timeTypes = this.concatAll(response_time_types.data.data);
      });
    } else {
      this.showMessageAccess();
    }
  },
  mounted() {
    this.selectedItemOnMenu('works/laborheader');
  },
  destroyed() {
    this.deselectedItemOnMenu('works/laborheader');
  },
};
</script>
